module.exports = "/_next/static/images/a1f0f90c73388a57e0c2e0374c1be309-nu-card-xs@2x.jpg.webp";